import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

export const PRINTER_SETUPS = gql`
  query PrinterSetups {
    printerSetups {
      tag
    }
  }
`;

export const PRINT_ALIGNMENT_TEMPLATE = gql`
  mutation PrintAlignmentTemplate (
    $type: String!
    $printerSetup: String!
    $quantity: Int!
  ) {
    printAlignmentTemplate (
      type: $type
      printerSetup: $printerSetup
      quantity: $quantity
    ) {
      ${ERRORS}
    }
  }
`;

export const UPDATE_PRINT_OFFSETS = gql`
  mutation UpdatePrintOffsets (
    $printOffsetX: Float!
    $printOffsetY: Float!
  ) {
    updatePrintOffsets (
      printOffsetX: $printOffsetX
      printOffsetY: $printOffsetY
    ) {
      ${ERRORS}
    }
  }
`;
